import React from 'react';
import PaletteIcon from '@mui/icons-material/Palette';
import ScienceIcon from '@mui/icons-material/Science';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';

export enum EventCategory {
  ARTS_PERFORMANCE = 'Arts & Performance',
  STEM_INNOVATION = 'STEM & Innovation',
  SPORTS_MOVEMENT = 'Sports & Fitness',
  LIFE_SKILLS_COOKING = 'Culinary & Food',
  GAMES_ENRICHMENT = 'Theme Camp',
}

export const categoryIcons: Record<EventCategory, React.ComponentType> = {
  [EventCategory.ARTS_PERFORMANCE]: PaletteIcon,
  [EventCategory.STEM_INNOVATION]: ScienceIcon,
  [EventCategory.SPORTS_MOVEMENT]: SportsSoccerIcon,
  [EventCategory.LIFE_SKILLS_COOKING]: RestaurantIcon,
  [EventCategory.GAMES_ENRICHMENT]: SportsEsportsIcon,
};

// Unique colors for each category
export const categoryColors: Record<EventCategory, { main: string; light: string; border: string }> = {
  [EventCategory.ARTS_PERFORMANCE]: {
    main: '#E91E63', // Pink
    light: '#FCE4EC',
    border: '#F8BBD0',
  },
  [EventCategory.STEM_INNOVATION]: {
    main: '#2196F3', // Blue
    light: '#E3F2FD',
    border: '#BBDEFB',
  },
  [EventCategory.SPORTS_MOVEMENT]: {
    main: '#4CAF50', // Green
    light: '#E8F5E9',
    border: '#C8E6C9',
  },
  [EventCategory.LIFE_SKILLS_COOKING]: {
    main: '#FF9800', // Orange
    light: '#FFF3E0',
    border: '#FFE0B2',
  },
  [EventCategory.GAMES_ENRICHMENT]: {
    main: '#9C27B0', // Purple
    light: '#F3E5F5',
    border: '#E1BEE7',
  },
};

// Mock category mapping for groups - this will be replaced with API data later
export const getGroupCategories = (groupId: number): EventCategory[] => {
  // Mock data - assign categories based on group ID
  const categoryMap: Record<number, EventCategory[]> = {
    1: [EventCategory.ARTS_PERFORMANCE, EventCategory.STEM_INNOVATION],
    2: [EventCategory.SPORTS_MOVEMENT, EventCategory.GAMES_ENRICHMENT],
    3: [EventCategory.LIFE_SKILLS_COOKING, EventCategory.GAMES_ENRICHMENT],
    4: [EventCategory.STEM_INNOVATION, EventCategory.ARTS_PERFORMANCE],
    5: [EventCategory.STEM_INNOVATION, EventCategory.SPORTS_MOVEMENT],
    6: [EventCategory.GAMES_ENRICHMENT, EventCategory.LIFE_SKILLS_COOKING],
  };

  // Default categories if group not in map
  return categoryMap[groupId] || [
    EventCategory.ARTS_PERFORMANCE,
    EventCategory.STEM_INNOVATION,
  ];
};

